module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-144x144.png";